<script lang="ts">
  import favicon from '$lib/assets/favicon.ico';
  import 'bootstrap/dist/css/bootstrap.min.css';
  import '$lib/assets/css/app.css';
  import '$lib/assets/css/datepicker.css';
  import '$lib/assets/css/form.css';
  import '$lib/assets/css/button.css';
  import '$lib/assets/css/navigation.css';
  import '$lib/assets/css/table.css';
  import '$lib/assets/css/animated.css';
  import { onMount } from 'svelte';
  import { auth } from '$lib/stores/auth.svelte';
  import { page } from '$app/state';
  import type { LayoutProps } from './$types';
  import NavigationItem from '$lib/components/common/layout/NavigationItem.svelte';
  import Navigation from '$lib/components/common/layout/Navigation.svelte';
  import Header from '$lib/components/common/layout/Header.svelte';
  import Breadcrumbs from '$lib/components/common/layout/Breadcrumbs.svelte';
  import Footer from '$lib/components/common/layout/Footer.svelte';
  import Toast from '$lib/components/common/Toast.svelte';
  import { toast } from '$lib/stores/toast.svelte';

  let { children, data }: LayoutProps = $props();

  onMount(() => {
    // initialize auth on app mount
    if (!auth.user) {
      auth.ping(true);
    }

    // ping auth every 5 minutes. redirect to logged out screen if null user returned
    const interval = setInterval(async () => {
      await auth.ping(false);
    }, 300_000);
    return () => {
      clearInterval(interval);
    };
  });

  let appTitle = $derived(data.meta.appTitle);
</script>

<svelte:head>
  <title>{appTitle}</title>
  <link rel="icon" href={favicon} />
</svelte:head>

<svelte:window
  onerror={e => {
    if (e instanceof ErrorEvent) {
      toast.showToast('danger', e.message);
    }
    return false;
  }}
  onunhandledrejection={e => {
    if (e.reason instanceof Error) {
      toast.showToast('danger', `An unexpected error occurred: ${e.reason.message}`);
    }
  }}
/>

<Header />
{#if auth.user && auth.user.role !== 'student'}
  <Navigation {appTitle}>
    {#if auth.user.role.includes('admin')}
      <NavigationItem href="/admin/classes" title="Classes" active={page.data.meta.activeNav === 'classes'} />
      <NavigationItem href="/admin/courses" title="Courses & Skills" active={page.data.meta.activeNav === 'courses'} />
      <NavigationItem href="/admin/users" title="Users" active={page.data.meta.activeNav === 'users'} />
      <NavigationItem href="/admin/reports" title="Reports" active={page.data.meta.activeNav === 'reports'} />
    {:else if auth.user.role === 'instructor'}
      <NavigationItem href="/instructors/classes" title="Classes" active={page.data.meta.activeNav === 'classes'} />
      <NavigationItem href="/instructors/reports" title="Reports" active={page.data.meta.activeNav === 'reports'} />
    {/if}
  </Navigation>
{/if}
{#if page.data.meta.breadcrumbs}
  <Breadcrumbs items={page.data.meta.breadcrumbs.items} activeTitle={page.data.meta.breadcrumbs.activeTitle} />
{/if}
{@render children?.()}
<Footer />
<Toast />
